import { CardPack, Playable, PlayableId } from "./types";
import { DataManager } from "./dataManager";

export const MaxLevel = 5;
export const packSize = 5; // Default pack size

export const TileSize = 32;
export const TileHalfSize = 16;
export const PreviewZIndex = 999;

// These will be populated by DataManager
export let CardPacks: CardPack[] = [];
export let AllPlayables: Map<PlayableId, Playable> = new Map();

export function initializeConstants(): void {
  const dataManager = DataManager.getInstance();
  AllPlayables = dataManager.playables;
  CardPacks = dataManager.cardPacks;
  (window as unknown as Record<string, unknown>).data = dataManager;
}

export function getPack(name: string): CardPack | undefined {
  return DataManager.getInstance().getPack(name);
}

export function GetPlayable(playableId: PlayableId): Playable {
  return DataManager.getInstance().getPlayable(playableId);
}
